import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../apiconfig";
import countries from "../countries/countries";

function SignUp() {
  const [userType, setUserType] = useState("candidate");
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    password: "",
    country: "",
    gst: "",
    // amount: "1770",
    amount: "1",
    pack_type: "3 months",
    clogo: null,
  });

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    let updatedFormData = { ...formData, [name]: value };

    // Update pack_type and calculate dates when the amount changes
    if (name === "amount") {
      switch (value) {
        case "1770":
          updatedFormData.pack_type = "3 months";
          break;
        case "2360":
          updatedFormData.pack_type = "6 months";
          break;
        case "3540":
          updatedFormData.pack_type = "12 months";
          break;
        default:
          updatedFormData.pack_type = "3 months";
      }
    }

    setFormData(updatedFormData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (userType === "employer") {
      // console.log("Submitting employer form", formData);
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        // Append the file directly
        if (key === "clogo" && value instanceof File) {
          formDataToSend.append("clogo", value);
        } else {
          formDataToSend.append(key, value);
        }
      });

      axios
        .post(`${BASE_URL}/user/dashboard/initiatePayment`, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          const { payment_url, params } = response.data || {};
          console.log("Response from initiatePayment:", response.data);

          if (!payment_url || !params) {
            console.error(
              "Missing payment_url or params in response",
              response.data
            );
            return;
          }

          // Payment redirection logic
          const form = document.createElement("form");
          form.action = payment_url;
          form.method = "POST";

          Object.entries(params).forEach(([key, value]) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = value;
            form.appendChild(input);
          });

          document.body.appendChild(form);
          form.submit();
        })
        .catch((error) => console.error("Error initiating payment", error));
    } else {
      const candidateData = {
        name: formData.name,
        mobile: formData.mobile,
        email: formData.email,
        password: formData.password
      };
      axios
        .post(
          `${BASE_URL}/user/dashboard/saveCandidate`,
          new URLSearchParams(formData).toString(), // Properly format data for CodeIgniter
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded", // Required for CodeIgniter
            },
          }
        )
        .then(() => {
          alert("Candidate registered successfully");
          navigate("/login");
        })
        .catch((error) => {
  if (error.response && error.response.status === 409) {
    alert("User already exists with this email.");
  } else {
    console.error("Error registering candidate", error);
    alert("Something went wrong while registering.");
  }
});
    }
  };

  return (
    <section className="account-section">
      <div className="tf-container">
        <div className="row">
          <div className="wd-form-login tf-tab">
            <h4>Sign Up Here</h4>
            <div className="menu-tab">
              <button
                onClick={() => setUserType("candidate")}
                style={{
                  backgroundColor:
                    userType === "candidate" ? "#14a077" : "white",
                  color: userType === "candidate" ? "white" : "black",
                }}
              >
                Candidate
              </button>
              <button
                onClick={() => setUserType("employer")}
                style={{
                  backgroundColor:
                    userType === "employer" ? "#14a077" : "white",
                  color: userType === "employer" ? "white" : "black",
                }}
              >
                Employer
              </button>
            </div>
            <div className="content-tab">
              <form onSubmit={handleSubmit}>
                <div className="ip">
                  <label>
                    Name<span>*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Name"
                    required
                  />
                </div>
                <div className="ip">
                  <label>
                    Mobile<span>*</span>
                  </label>
                  <input
                    type="text"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    placeholder="Mobile"
                    required
                  />
                </div>
                <div className="ip">
                  <label>
                    Email<span>*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Email"
                    required
                  />
                </div>
                <div className="ip">
                  <label>
                    Password<span>*</span>
                  </label>
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="Password"
                    required
                  />
                </div>
                {userType === "employer" && (
                  <>
                    <div className="ip">
                      <label>
                        Country<span>*</span>
                      </label>
                      <select
                        name="country"
                        value={formData.country}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Select Country</option>
                        {countries.map((country) => (
                          <option key={country} value={country}>
                            {country}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="ip d-flex flex-column">
                      <label>
                        Company Logo<span>*</span>
                      </label>
                      <input
                        type="file"
                        name="clogo"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file && file.size > 10 * 1024 * 1024) {
                            alert("File size must be less than 10MB");
                            e.target.value = "";
                            return;
                          }
                          setFormData({ ...formData, clogo: file });
                        }}
                        required
                      />
                    </div>
                    {formData.country === "India" && (
                      <div className="ip">
                        <label>
                          GST Number<span>*</span>
                        </label>
                        <input
                          type="text"
                          name="gst"
                          value={formData.gst}
                          onChange={handleInputChange}
                          placeholder="GST Number"
                          required
                        />
                      </div>
                    )}
                    <div className="ip">
                      <label>
                        Select Amount<span>*</span>
                      </label>
                      <select
                        name="amount"
                        value={formData.amount}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="1770">
                          1500 +270 GST Rupee For 3 months
                        </option>
                        <option value="2360">
                          2000 +360 GST Rupees For 6 months
                        </option>
                        <option value="3540">
                          3000 +540 GST Rupees For 12 months
                        </option>
                      </select>
                    </div>
                  </>
                )}
                <button type="submit">
                  {userType === "employer" ? "Proceed to Payment" : "Register"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SignUp;
